import { useState } from "react";
import { toast } from "sonner";
import { requestOTPAPI, verifyOTPAPI } from "../../actions/loginAction";

export const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

export const useLoginData = (onLogin, navigate) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [hasOtpError, setHasOtpError] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    if (!password) {
      toast.error("Please enter your password");
      return;
    }

    setIsLoading(true);

    try {
      const response = await requestOTPAPI(email, password);

      if (response.success) {
        toast.success(response.message || "OTP sent to your email");
        sessionStorage.setItem("otpEmail", email);
        setShowOtpForm(true);

        if (typeof onLogin === "function") {
          onLogin(email);
        }
      } else {
        toast.error(response.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(error?.message || "Failed to send OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setHasOtpError(false);
    setOtpErrorMessage("");

    if (!otp || otp.length === 0) {
      setHasOtpError(true);
      setOtpErrorMessage("Please enter OTP");
      toast.error("Please enter OTP");
      return;
    }

    if (otp.length < 6) {
      setHasOtpError(true);
      setOtpErrorMessage("Please enter complete 6-digit OTP");
      toast.error("Please enter complete 6-digit OTP");
      return;
    }

    setIsLoading(true);

    try {
      const response = await verifyOTPAPI(email, otp);

      if (response.success === true) {
        toast.success(response.message || "OTP verified successfully!");
        setHasOtpError(false);
        setOtpErrorMessage("");
        navigate("/dashboard");
      } else {
        setHasOtpError(true);
        setOtpErrorMessage(response.message || "Invalid OTP. Please try again.");
        toast.error(response.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      setHasOtpError(true);
      setOtpErrorMessage(error?.response?.data?.message || error?.message || "Invalid OTP. Please try again.");
      toast.error(error?.response?.data?.message || error?.message || "Invalid OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpChange = (value) => {
    setOtp(value);
    if (hasOtpError) {
      setHasOtpError(false);
      setOtpErrorMessage("");
    }
  };

  const handleBackToLogin = () => {
    setShowOtpForm(false);
    setOtp("");
    setHasOtpError(false);
    setOtpErrorMessage("");
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    showPassword,
    togglePasswordVisibility,
    isLoading,
    setIsLoading,
    handleSubmit,
    showOtpForm,
    otp,
    setOtp,
    hasOtpError,
    otpErrorMessage,
    handleVerifyOtp,
    handleOtpChange,
    handleBackToLogin,
  };
};
